// #region Imports
import { defineComponent } from "vue";
// #endregion
export default defineComponent({
    // #region Core
    computed: {
        currentWindow() {
            return utils.findVueComponent(this, ["g-modal-popup", "g-modal-slide"]);
        },
    },
    methods: {
        close(resulstate) {
            this.currentWindow.close(resulstate);
        }
    }
    // #endregion
});
